import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const HeaderButton = ({
  title,
  handleClick,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="dropdown btn-group top_right_pop_btn_position"
      >
        <button
          className="top_righ_pop_btn"
          aria-controls="ewalletTrnsfer"
          onClick={handleClick}
        >
          {t(title)}
        </button>
      </div>
    </>
  );
};

export default HeaderButton;
